import { cn } from "@omni/utils/styles";
import { MouseEvent } from "react";

import { AutocompleteItem } from "@/components/Search/SearchBar/AutocompleteItem/autocompleteItem.container";
import { BaseItemProps } from "@/components/Search/SearchBar/ResultsPanel/resultsPanel.templates";
import { RecentSearchesSourceType } from "@/components/Search/SearchBar/searchBar.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type RecentSearchesItemProps = BaseItemProps<
    RecentSearchesSourceType,
    {
        onRemoveRecentSearchItem: (label: string) => void;
    }
>;

const RecentSearchesItem = ({
    item,
    autocompleteState,
    autocompleteActions,
    onRemoveRecentSearchItem
}: RecentSearchesItemProps) => {
    const { t } = useGranite();

    const handleOnRemoveClick = (event: MouseEvent) => {
        event.stopPropagation();
        onRemoveRecentSearchItem(item.label);
    };

    return (
        <AutocompleteItem<RecentSearchesSourceType>
            query={item.label}
            className={cn("tw:justify-between tw:flex tw:rounded-sm")}
            itemId={item.__autocomplete_id}
            autocompleteState={autocompleteState}
            autocompleteActions={autocompleteActions}
            getRedirectUrl={() => item.redirectUrl}
        >
            <div className={cn("tw:flex")}>
                <div>
                    <i className={cn("las la-redo-alt", "tw:pr-2 tw:mt-1")} />
                </div>
                {item.label}
            </div>
            <button
                type={"button"}
                className={cn("tw:text-black tw:bg-transparent tw:border-none")}
                onClick={handleOnRemoveClick}
                aria-label={t("accessibility.searchBox.recentSerach")}
            >
                <i className={cn("las la-times")} />
            </button>
        </AutocompleteItem>
    );
};

export { RecentSearchesItem };
